import { ActionReducerMapBuilder, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import SettingService from '../../features/settings/services/SettingService';
import { SettingsToEcom } from '../../models/ppoints/settings/SettingsToEcom';
import { RootState } from '../store';

export interface SettingsState {
    settings: SettingsToEcom | null;
    fetching: boolean;
    error: boolean;
}

const initialState: SettingsState = {
    settings: null,
    fetching: true,
    error: false,
};

export const settingsThunk = createAsyncThunk<SettingsToEcom, { skipLoading?: boolean }>(
    'settings/get',
    async (settings, thunkAPI) => {
        try {
            return await SettingService.getAll();
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const settingsSetThunk = createAsyncThunk<
    // Return type of the payload creator
    SettingsToEcom,
    // First argument to the payload creator
    { settings: SettingsToEcom }
>('settings/set', async ({ settings }, thunkAPI) => {
    try {
        const state = thunkAPI.getState() as RootState;
        const ecomId = state.ecoms.selected?.id || null;
        if (!ecomId) {
            return thunkAPI.rejectWithValue('Ecom not selected');
        }
        return await SettingService.setSettings(ecomId, settings);
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

const settingsGetCases = (asyncThunk, builder: ActionReducerMapBuilder<SettingsState>): void => {
    builder.addCase(asyncThunk.fulfilled, (state, action) => {
        state.settings = action.payload;
        state.fetching = false;
        state.error = false;
    });
    builder.addCase(asyncThunk.pending, (state, action) => {
        if (!action.meta.arg.skipLoading) {
            state.fetching = true;
        }
        state.error = false;
    });
    builder.addCase(asyncThunk.rejected, (state) => {
        state.fetching = false;
        state.error = true;
        // TODO: add banner!!!!
        // toastUtils.error('Failed to fetch data!');
    });
};
const settingsSetCases = (asyncThunk, builder: ActionReducerMapBuilder<SettingsState>): void => {
    builder.addCase(asyncThunk.fulfilled, (state, action) => {
        if (state.settings) {
            for (const setting in action.payload) {
                state.settings[setting] = action.payload[setting];
            }
        }
        state.fetching = false;
        state.error = false;
    });
    builder.addCase(asyncThunk.pending, (state) => {
        state.fetching = true;
        state.error = false;
    });
    builder.addCase(asyncThunk.rejected, (state) => {
        state.fetching = false;
        state.error = true;
        // TODO: add banner!!!!
        // toastUtils.error('Failed to save settings!');
    });
};

export const settingsSlice = createSlice({
    name: 'settings',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        settingsGetCases(settingsThunk, builder);
        settingsSetCases(settingsSetThunk, builder);
    },
});

export const settingsActions = settingsSlice.actions;

export default settingsSlice.reducer;
